// Sign-out handler that downstream services link to. Performs a real Amplify
// signOut() (clears localStorage), clears the rw_token cookie, then bounces
// the user back to /login with the original redirect target preserved so
// the post-login flow can return them to the originating service.
//
// Why this exists: just clearing the rw_token cookie on a downstream service
// like cam.redwoodoperations.com isn't enough — Amplify still has a valid
// session in localStorage on auth.redwoodoperations.com, so a refresh would
// silently mint a new ID token (with the same stale `cognito:groups`) and
// the user gets stuck on a No-Access screen with no way out. This route is
// the single chokepoint that downstream services should redirect to so that
// a sign-out actually means "sign out".

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { signOut } from '../lib/auth.js';

export function Logout() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirect = params.get('redirect');
    (async () => {
      try {
        await signOut();
      } catch (err) {
        // Even if Amplify throws (e.g., already signed out), keep going so the
        // user isn't stranded — clearIdTokenCookie() inside signOut() runs
        // best-effort and Hub listeners also clear on signedOut events.
        console.warn('signOut threw, continuing anyway', err);
      }
      const target = redirect
        ? `/login?redirect=${encodeURIComponent(redirect)}`
        : '/login';
      navigate(target, { replace: true });
    })();
  }, [location, navigate]);

  return <div className="p-12 text-brand-500">Signing out…</div>;
}
